import { Injectable, SecurityContext } from '@angular/core';
import { XhrService } from '../../core/services/xhr-service/xhr.service';
import {
  FindUserByNicknevRequestDto,
  FindUserByNicknevResponseDto,
  FranchisePartnerSendRequestDto,
} from './personal-site.interfaces';
import { API } from '../../global/API.constants';
import { Observable } from 'rxjs';
import { ExposedEnvironmentVariable } from '../../../environments/environment-variables';
import { DomSanitizer } from '@angular/platform-browser';
import { EnvironmentVariablesService } from '../../core/services/environment-variable-service/environment-variables.service';

@Injectable({
  providedIn: 'root',
})
export class PersonalSiteService {
  constructor(
    private xhr: XhrService,
    private sanitizer: DomSanitizer,
    private environmentVariablesService: EnvironmentVariablesService
  ) {}

  findByNicknev(request: FindUserByNicknevRequestDto): Observable<FindUserByNicknevResponseDto> {
    return this.xhr.post<FindUserByNicknevResponseDto>(API.user.findByNickname, request, {}, '', false);
  }
  getImageSrc(nicknev: string): string {
    const constructedImageSrc = `${this.environmentVariablesService.getVar(
      ExposedEnvironmentVariable.PROFILKEP_URL
    )}/${nicknev}.jpg`;
    return this.sanitizer.sanitize(SecurityContext.URL, constructedImageSrc);
  }

  send(request: FranchisePartnerSendRequestDto): Observable<unknown> {
    return this.xhr.post(API.contactFranchisePartner.send, request, {});
  }
}
